import {Component, Input, OnInit} from '@angular/core';
import {BreadcrumbsService} from '../../services/breadcrumbs/breadcrumbs.service';
import {Router} from '@angular/router';

export type BreadcrumbItem = {
  label: string
  routerLink: string
}

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {

  public reversedHeap: BreadcrumbItem[] = [];

  constructor(public breadcrumbService: BreadcrumbsService, public router: Router) {
  }

  @Input() segments: BreadcrumbItem[] = [];

  ngOnInit(): void {
    this.reversedHeap = this.breadcrumbService.breadcrumbHeap.slice().reverse();
  }

  /**
   * Gestisce la navigazione a ritroso dei livelli di navigazione inversi rispetto a index.
   * @param event
   * @param breadcrumbItem
   * @param index
   */
  public navigateToBreadcrumbItem(event: MouseEvent, breadcrumbItem: BreadcrumbItem, index: number) {
    event.preventDefault();

    // Calcoliamo il numero di livelli a ritroso che stiamo cercando di navigare
    const levelsToRemove = this.breadcrumbService.breadcrumbHeap.length - index;

    // Aggiorniamo l'heap tramite il service
    this.breadcrumbService.removeNavigationLevels(levelsToRemove);

    // Navighiamo verso l'item
    this.router.navigateByUrl(breadcrumbItem.routerLink);

  }
}
